export * from "./configuration.page";
